import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-serif font-bold text-white mb-4 bg-gradient-to-r from-gold-400 to-gold-600 bg-clip-text text-transparent">
              European Touch
            </h3>
            <p className="text-sm mb-4 leading-relaxed">
              Premium painting services for residential and commercial properties. Precision, quality, and excellence in every brushstroke.
            </p>
            <div className="flex items-center space-x-2 text-sm mb-2">
              <div className="w-2 h-2 rounded-full bg-gold-500"></div>
              <span className="text-white font-medium">Fully Insured & Licensed</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-gold-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-gold-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-sm hover:text-gold-400 transition-colors">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-gold-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-gold-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-gold-400 transition-colors cursor-pointer">Interior Painting</li>
              <li className="hover:text-gold-400 transition-colors cursor-pointer">Exterior Painting</li>
              <li className="hover:text-gold-400 transition-colors cursor-pointer">Custom Finishes</li>
              <li className="hover:text-gold-400 transition-colors cursor-pointer">Commercial Painting</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a href="tel:+14163001663" className="flex items-start space-x-3 text-sm hover:text-gold-400 transition-colors group">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:text-gold-400" />
                <div>
                  <div className="font-medium text-white">Phone</div>
                  <div>(416) 300-1663</div>
                </div>
              </a>
              <a href="mailto:info@etppainting.com" className="flex items-start space-x-3 text-sm hover:text-gold-400 transition-colors group">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:text-gold-400" />
                <div>
                  <div className="font-medium text-white">Email</div>
                  <div>info@etppainting.com</div>
                </div>
              </a>
              <div className="flex items-start space-x-3 text-sm">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-gold-500" />
                <div>
                  <div className="font-medium text-white">Service Area</div>
                  <div>Greater Toronto Area and Beyond</div>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-6">
              <a href="https://instagram.com/european_touch_painting_" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-gray-800 flex items-center justify-center hover:bg-gold-500 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} European Touch Painting. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span className="cursor-default">Privacy Policy</span>
              <span className="cursor-default">Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
